import React from 'react';
import PropTypes from 'prop-types';
import lstrings from '../../../../../utils/LStrings';
import { map } from 'lodash'
import { Panel } from 'react-bootstrap';
import ScrollableAnchor from 'react-scrollable-anchor'
import TablePlain from '../../../../../components/table-plain/TablePlain';
import TableUtils from '../../../../../utils/TableUtils';
import PermissionChecker from '../../../../../components/permission-checker/PermissionChecker';
import 'react-bootstrap-table/css/react-bootstrap-table.css';

class PanelVinculos extends React.Component {

    onRequestInfo = (infoKey, infoTitle) => {
        this.props.onRequestInfo(lstrings.vinculos_title, infoTitle);
    }

    render() {
        let titulo = <h4><i className="fa fa-share-alt"></i> {lstrings.vinculos_title}</h4>;

        return (
            <ScrollableAnchor id={'panel-vinculos'}>
                <Panel collapsible defaultExpanded header={titulo}>
                    <PermissionChecker infoKey='vinculos' infoTitle='Personas relacionadas a la empresa' data={this.props.info}
                        onRequestInfo={this.onRequestInfo} hidePanels={this.props.hidePanels}>
                        {this.props.info && <TablePlain columns={["CUIL", "Cargo", "Nombre"]}
                            rows={map(this.props.info.datos, (item, ix) => <tr key={ix}>
                                <td>{TableUtils.cuilFormat(item.cuilvinculo)}</td>
                                <td>{TableUtils.stringFormat(item.cargo)}</td>
                                <td>{item.nombre}</td>
                            </tr>)} />}
                    </PermissionChecker>
                </Panel>
            </ScrollableAnchor>
        );
    }
}

PanelVinculos.propTypes = {
    info: PropTypes.any,
    onRequestInfo: PropTypes.func,
    hidePanels: PropTypes.any
};

export default PanelVinculos;


// WEBPACK FOOTER //
// ./src/scenes/empresas/components/empresas-detalle/components/PanelVinculos.js